import ButtonAction from '../../common/components/Button/ButtonAction.js'
import {renderMOs} from '../../data/mos.js'
import {showEditMOLineModal} from './Modals/EditMOLineModal.js'
import {showUpdateMOStatusModal} from './Modals/UpdateMOStatusModal.js'
import AddMOTagsDropdown from './AddMOTagsDropdown.js'
import {showCreateMOModal} from './Modals/CreateMOModal.js'
import {openSyncLoadingTab} from '../AbodeForm/abodeFormFunctions.js'

function openMOPrintTab(referenceIDs) {
  const tab = openSyncLoadingTab()

  if (!tab) {
    return
  }

  renderMOs(referenceIDs, tab)
}

/**
 * ActionsForSelected component renders action buttons for selected MOs.
 *
 * @param {Object} props - The component props.
 * @param {Array} props.referenceIDs - The reference IDs of the selected MOs.
 *
 * @returns {React.ReactElement} The rendered component.
 */
export default function ActionsForSelected({referenceIDs}) {
  return (
    <>
      <li className="inline-block fs-n0 divider--left">
        <button
          className="btn btn--action v-align-base"
          type="button"
          onClick={() => showUpdateMOStatusModal(referenceIDs)}
        >
          Update Status
        </button>
      </li>

      {referenceIDs.length === 1 && (
        <>
          <li className="inline-block fs-n0 margin-left-10">
            <button
              className="btn btn--action v-align-base"
              type="button"
              onClick={() =>
                showCreateMOModal({cloneFromReferenceID: referenceIDs[0]})
              }
            >
              Clone MFG Order
            </button>
          </li>
          <li className="inline-block fs-n0 margin-left-10">
            <button
              className="btn btn--action v-align-base"
              type="button"
              onClick={() => showEditMOLineModal(referenceIDs[0])}
            >
              Add Line
            </button>
          </li>
        </>
      )}
      <AddMOTagsDropdown referenceIDs={referenceIDs} />
      <li className="inline-block fs-n0 margin-left-10">
        <ButtonAction onClick={() => openMOPrintTab(referenceIDs)}>
          Preview/Print
        </ButtonAction>
      </li>
    </>
  )
}
